"use client";

type SideRailProductTitleProps = {
  title: string;
};

export default function SideRailProductTitle({
  title,
}: SideRailProductTitleProps) {
  return (
    <p className="text-primary-500 tracking-tight font-black text-3xl m-0">
      {title}
    </p>
  );
}
